import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { IconSize } from "@odx/angular/components/icon";
import { TabId } from "@project/project-details/project-details-tab-id";

export interface MobileNavItem {
  id: TabId;
  label: string;
  icon: string;
  isReadOnly?: boolean;
  testId: string;
}

@Component({
  selector: "app-mobile-bottom-nav",
  templateUrl: "./mobile-bottom-nav.component.html",
  styleUrls: ["./mobile-bottom-nav.component.scss"],
  standalone: true,
  imports: [CommonModule, UiKitModule],
})
export class MobileBottomNavComponent {
  @Input() tabIndex: number = 0;
  @Input() isReadOnlyUser: boolean = false;
  @Input() items: MobileNavItem[] = [];
  @Output() tabSelected = new EventEmitter<number>();

  isExpanded: boolean = false;
  iconSize: IconSize = "large";
  pressedTestId: string | null = null;
  showMoreButtonText: string = $localize`:@@projectDetails.navBar.mobile.showMore:Mehr`;
  showLessButtonText: string = $localize`:@@projectDetails.navBar.mobile.showLess:Weniger`;

  get visibleItems(): MobileNavItem[] {
    return this.items.filter((item) => !item.isReadOnly || !this.isReadOnlyUser);
  }

  get primaryItems(): MobileNavItem[] {
    return this.visibleItems.slice(0, 3);
  }

  get secondaryItems(): MobileNavItem[] {
    return this.visibleItems.slice(3, 6);
  }

  get isSecondaryRowActive(): boolean {
    return this.tabIndex >= 3 && this.tabIndex < this.visibleItems.length;
  }

  get topRowItems(): MobileNavItem[] {
    return this.isSecondaryRowActive ? this.secondaryItems : this.primaryItems;
  }

  get bottomRowItems(): MobileNavItem[] {
    return this.isSecondaryRowActive ? this.primaryItems : this.secondaryItems;
  }

  dynamicTabIndex(item: MobileNavItem): number {
    return this.visibleItems.indexOf(item);
  }

  selectTab(item: MobileNavItem): void {
    this.tabSelected.emit(this.dynamicTabIndex(item));
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }
}
